/**
 * `work`, or `fallback` once `ms` have passed without an answer. For browser
 * APIs that can stay silent for good — an IndexedDB open after an interrupted
 * start calls back with nothing at all.
 */
export function withTimeout<T>(
    work: Promise<T>,
    ms: number,
    fallback: T
): Promise<T> {
    return Promise.race([
        work,
        new Promise<T>((resolve) => setTimeout(() => resolve(fallback), ms))
    ]);
}
